import styled from 'styled-components';
import { Text } from '../../../UI/Text';
import { media } from '../../../../Utils/mediaQueries';

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

// Top summary
export const SummaryBlock = styled.div`
    width: 100%;
    height: 78px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    border-bottom: ;
`;

export const SummaryLeftSide = styled.div`
    flex: 1;
    display: flex;
`;

export const SummaryImageContainer = styled.div`
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
    background-image: url(${({ src }) => (src ? src : null)});
    border-radius: 8px;
`;

export const SummaryImage = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${({ src }) => (src ? src : null)});
    background-size: cover;
    border-radius: 8px;
`;

export const SummaryText = styled.div`
    flex: 1;
    padding: 2px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const SummaryRightSide = styled.div`
    flex: 1;
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const FinishButton = styled.button`
    height: 24px;
    width: 75px;
    border-radius: 100px;
    background-color: #ffffff;
    border: none;
    color: #fb4a52;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    outline: none;

    &:disabled {
        opacity: 0.75;
    }
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${media.tablet`
        justify-content: flex-end;
    `};
`;

export const StatColumn = styled.div`
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

// Rounds
export const RoundsInfoHeader = styled.div`
    width: 100%;
    height: 30px;
    background-color: #131313;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 24px;
`;

export const InfoHeaderSide = styled.div`
    flex: 1;
    display: flex;
`;

export const InfoHeaderRightSide = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const InfoHeaderItem = styled.div`
    width: ${props => (props.width ? props.width : '50px')};
    margin-right: ${props => (props.marginRight ? props.marginRight : '20px')};
    display: flex;
    justify-content: flex-end;

    ${media.tablet`
        margin-right: 15px;
    `};
`;

export const RoundsContent = styled.div`
    width: 100%;
    flex: 1;
    padding: 24px 12px;
    overflow: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar-track {
        background: #000;
    }

    &::-webkit-scrollbar {
        width: 10px;
        background: #000;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        border: 1px solid #333333;
        background: #000;
    }
`;

export const ExerciseRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 6px 0;
`;

export const ExerciseRowSide = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
`;

export const ExerciseRowRightSide = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const Row = styled.div`
    display: flex;
`;

export const HeaderRow = styled.div`
    display: flex;

    ${media.tablet`
        padding-right: 20px;
    `};
`;

export const ExerciseActionsRow = styled.div`
    display: flex;

    ${media.tablet`
        display: none;
    `};
`;

export const KebabMenuContainer = styled.div`
    display: none;

    ${media.tablet`
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    `};
`;

export const ActionIconItem = styled.div`
    width: 15px;
    margin: 0 5px;
    cursor: pointer;
`;

export const ExerciseRowItem = styled.input`
    width: ${props => (props.width ? props.width : '50px')}
    margin-right: 20px;
    font-size: 14px;
    color: white;
    font-weight: bold;
    text-align: right;
    background-color: #0e0e0e;
    border: none;

    &:focus + .bar {
        width: 100px;
        height: 50px; 
        background-color: white;
    }

`;

export const RowIndex = styled(Text)`
    width: 20px;
    weight: bold;
    color: #fff;
    opacity: 0.5;
    text-align: right;
`;

export const ExerciseIconWrapper = styled.div`
    width: 40px;
    height: 40px;
    background-image: linear-gradient(160deg, #41464d, #16171b);
    border-radius: 100px;
    border: solid 3px rgba(255, 255, 255, 0.31);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 20px;
    // position: absolute;
    // left: 30px;

    ${media.tablet`
        display: none;
    `};
`;

export const ExerciseIcon = styled.div`
    width: 24px;
    height: 24px;
    background-image: url(${({ img }) => (img ? img : null)});
    background-size: cover;
`;

export const ExerciseNameColumn = styled.div`
    padding: 1px 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-left: 20px;
`;

export const RoundRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
`;

export const WorkoutTitleInput = styled(ExerciseRowItem)`
    width: 100%;
    margin: 0;
    text-align: left;
    font-weight: 200;
    outline: none;
`;

export const ExerciseTimeInput = styled.input`
    // width: ${props => (props.width ? props.width : '50px')}
    width: 25px;
    // margin-right: 20px;
    font-size: 14px;
    color: white;
    font-weight: bold;
    text-align: center;
    background-color: #0e0e0e;
    border: none;
    outline: none;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/style.js